import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import { toast } from 'react-hot-toast';
import './Contact.css'

const Contact = () => {

    const form = useRef();

    const sendEmail = (e) => {

        e.preventDefault();

        emailjs.sendForm('service_vj9xcfu', 'template_rk1igog', form.current, 'huB7HdbtLQHtlBqmr')
            .then((result) => {
                toast.success('Message is sent');
                console.log(result.text);


            }, (error) => {
                toast.error(error.text);
                console.log(error.text);

            });



    };

    return (
        <div className='flex flex-col md:flex-row mx-10 my-28 items-center' id="contact">
            <div className='basis-1/2'>
                <span className='title'>Contact</span>
                <h3 className='subtitle'>Get in Touch</h3>
                <p className='contact-info text-gray-400'>Please fill out the form on this section to contact with me. Or call between 9:00 a.m. and 8:00 p.m. ET, Monday through Friday</p>

                <div>
                    <div className="card card-side bg-base-100 shadow-sm border items-center p-3 my-5">
                        <div className='bg-violet-100 p-3 rounded-full'>
                            <i className="text-violet-700 fa fa-phone" aria-hidden="true"></i>

                        </div>
                        <div className="card-body">
                            <div>
                                <p className='contact-title'>Contact on phone</p>
                                <p className='contact-info'>+8801981504997</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="card card-side bg-base-100 shadow-sm border items-center p-3 my-3">
                        <div className='bg-violet-100 p-3 rounded-full'>
                            <i className="text-violet-700 fa fa-envelope" aria-hidden="true"></i>
                            {/* mail */}

                        </div>
                        <div className="card-body">
                            <div>
                                <p className='contact-title'>Contact on mail</p>
                                <p className='contact-info'>abdurrahmany418@gmail.com</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="card card-side bg-base-100 shadow-sm border items-center p-3 my-3">
                        <div className='bg-violet-100 p-3 rounded-full'>
                            <i className="text-violet-700 fa fa-location-dot" aria-hidden="true"></i>

                        </div>
                        <div className="card-body">
                            <div>
                                <p className='contact-title'>Contact address</p>
                                <p className='contact-info'>693/1, Sarai masjid road, Dania, Dhaka, 1236</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* second part  */}
            <div className=' basis-1/2'>
                <h3 className='mx-5 mb-4 title'>Send a message</h3>
                <form ref={form} onSubmit={sendEmail} className="flex flex-col mx-5 gap-5" >
                    <input type="text" placeholder="Name" name="user_name" className="input input-bordered input-md w-full max-w-xs" />
                    <input type="email" placeholder="Email" name="user_email" className="input input-bordered input-md w-full max-w-xs" />
                    <textarea className="textarea textarea-bordered" name='message' placeholder="Message"></textarea>
                    <input className='submit p-3 rounded-md font-bold text-white cursor-pointer' type="submit" value="Send" />
                </form>
            </div>
        </div>
    );
};

export default Contact;